<script lang="ts" setup></script>

<template>
  <div class="fTable is--products-table has--selects">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/helpers/include-media';

.form__element {
  margin-bottom: 0;
}

.has--selects {
  width: 100%;
  border: 1px solid $borderColor;
  overflow: hidden;

  @include themify($themes) {
    border-radius: rem-calc(themed('cardBorderRadius'));
  }
}
</style>
